import { FC } from "react";
import { Button } from "../../custom";
import styles from "./styles.module.scss";
import { UseReactToPrintFn } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";

interface ComponentProps {
  onClick: () => void;
  isLoading?: boolean;
  isEdit?: boolean | undefined;
  isPrevButton?: boolean;
  onNextClick?: () => void;
  isReview?: boolean;
  type?: "submit" | "button";
  backButtonText?: string;
  onExit?: () => void;
  disabled?: boolean;
  onPrint?: UseReactToPrintFn;
  hasPaid?: boolean;
}

const OnboardingButtonGroup: FC<ComponentProps> = ({
  isLoading,
  onClick,
  isPrevButton = true,
  isEdit,
  isReview,
  onNextClick,
  onExit,
  backButtonText = "Previous",
  type = "button",
  disabled,
  onPrint,
  hasPaid,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.buttonGroup}>
      {isPrevButton && (
        <Button type="button" onClick={onClick} text={backButtonText} />
      )}
      {isReview && (
        <Button type="button" text="Save and Exit" onClick={onExit} />
      )}

      <Button type="button" text="Print" onClick={onPrint} />

      {!isEdit && !hasPaid && (
        <Button
          type={type}
          text={
            isEdit
              ? "Edit"
              : isReview
              ? "Proceed to payment"
              : "Save and Continue"
          }
          isLoading={isLoading}
          onClick={onNextClick}
          disabled={disabled}
        />
      )}
      {hasPaid && (
        <Button
          type="button"
          text="Go to Dashboard"
          onClick={() => navigate(routes.dashboard.dashboard)}
        />
      )}
    </div>
  );
};

export default OnboardingButtonGroup;
